import React, { useState } from "react";
const TaxCategories = () => {
  const [categories, setCategories] = useState([
    { id: 1, name: "Books", order: 1 },
    { id: 2, name: "Electronics & Software", order: 5 },
    { id: 3, name: "Downloadable Products", order: 10 },
    { id: 4, name: "Jewelry", order: 15 },
    { id: 5, name: "Apparel", order: 20 },
  ]);
  const [newName, setNewName] = useState("");
  const [newOrder, setNewOrder] = useState(0);
  const handleAdd = () => {
    if (newName.trim() === "") return;
    setCategories([
      ...categories,
      { id: Date.now(), name: newName, order: Number(newOrder) },
    ]);
    setNewName("");
    setNewOrder(0);
  };
  const handleDelete = (id) => {
    setCategories(categories.filter((c) => c.id !== id));
  };
  return (
    <div className="p-4 md:p-8 bg-gray-50 min-h-screen">
      <div className="max-w-6xl mx-auto bg-white shadow rounded-lg p-6">
        {/* Header */}
        <h1 className="text-2xl font-semibold mb-2">Tax categories</h1>
        <p className="text-sm text-gray-600 mb-4">
          Learn more about{" "}
          <a href="#" className="text-blue-600 underline">
            tax management
          </a>
          .
        </p>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200 text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="text-left px-4 py-2 border-b border-gray-200 w-1/2">
                  Name
                </th>
                <th className="text-left px-4 py-2 border-b border-gray-200">
                  Display order
                </th>
                <th className="text-left px-4 py-2 border-b border-gray-200">
                  Edit
                </th>
                <th className="text-left px-4 py-2 border-b border-gray-200">
                  Delete
                </th>
              </tr>
            </thead>
            <tbody>
              {categories.map((cat, idx) => (
                <tr
                  key={cat.id}
                  className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}
                >
                  <td className="px-4 py-2 border-b border-gray-200">
                    {cat.name}
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200">
                    {cat.order}
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200">
                    <button className="flex items-center gap-1 bg-gray-100 border border-gray-300 px-3 py-1 rounded hover:bg-gray-200 transition text-sm">
                      ✏️ Edit
                    </button>
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200">
                    <button
                      onClick={() => handleDelete(cat.id)}
                      className="flex items-center gap-1 bg-red-100 border border-red-300 px-3 py-1 rounded hover:bg-red-200 transition text-sm text-red-700"
                    >
                      🗑 Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="flex flex-col sm:flex-row justify-between items-center mt-4 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <button className="border border-gray-300 px-3 py-1 rounded hover:bg-gray-100 transition">
              Previous
            </button>
            <button className="bg-blue-600 text-white px-3 py-1 rounded">
              1
            </button>
            <button className="border border-gray-300 px-3 py-1 rounded hover:bg-gray-100 transition">
              Next
            </button>
          </div>
          <div className="flex items-center gap-2 mt-3 sm:mt-0">
            <span>Show</span>
            <select className="border border-gray-300 rounded px-2 py-1">
              <option>15</option>
              <option>30</option>
              <option>50</option>
            </select>
            <span>items</span>
          </div>
        </div>

        {/* Add new record */}
        <div className="mt-6 border-t border-gray-200 pt-4">
          <h2 className="text-lg font-semibold mb-2">Add new record</h2>

          <div className="space-y-3">
            <div className="flex flex-col sm:flex-row sm:items-center gap-2">
              <label className="font-medium text-sm w-32">Name</label>
              <input
                type="text"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                className="border border-gray-300 rounded px-3 py-1 flex-1"
              />
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center gap-2">
              <label className="font-medium text-sm w-32">Display order</label>
              <input
                type="number"
                value={newOrder}
                onChange={(e) => setNewOrder(e.target.value)}
                className="border border-gray-300 rounded px-3 py-1 w-32"
              />
            </div>

            <div className="sm:pl-32">
              <button
                onClick={handleAdd}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition text-sm"
              >
                Add new record
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxCategories;
